import { render, staticRenderFns } from "./AllEmailTemplates.vue?vue&type=template&id=5899a630&scoped=true&"
import script from "./AllEmailTemplates.vue?vue&type=script&lang=js&"
export * from "./AllEmailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./AllEmailTemplates.vue?vue&type=style&index=0&id=5899a630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5899a630",
  null
  
)

export default component.exports